'use client';

import { useMemo } from 'react';
import { useStore } from 'zustand';

import { cartStore } from '@/store/cart/cart.store';
import { CartItem } from '@/types/cart.types';
import { getCartTotal } from '@/utils/cart/get-cart-total.util';

export interface UseCartResult {
  items: CartItem[];
  itemCount: number;
  total: number;
  isLoading: boolean;
  hasError: boolean;
  isEmpty: boolean;
  hasItems: boolean;
}

export function useCart(): UseCartResult {
  const cart = useStore(cartStore, (state) => state.cart);
  const status = useStore(cartStore, (state) => state.status);

  const items = useMemo(() => cart?.items ?? [], [cart]);
  const total = useMemo(() => getCartTotal(items), [items]);

  return {
    items,
    itemCount: items.length,
    total,
    isLoading: status === 'idle' || status === 'loading',
    hasError: status === 'error',
    isEmpty: status === 'loaded' && items.length === 0,
    hasItems: status === 'loaded' && items.length > 0,
  };
}
